import React from "react";
import { useFieldArray } from "react-hook-form";
import Input from "../Input/Input";
import styles from "./Achievements.module.css";

const Achievements = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "achievements",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        title: "",
        type_of_achievement: "",
        awarding: "",
        recognizing_body: "",
        description: "",
        year: "",
      });
    }
  }, [fields, append]);

  return (
    <div>
      <div className={styles.heading}>
        <h2>Achievements</h2>

      </div>
      {fields.map((item, idx) => (
        <div className={styles.grid3} key={item.id}>
          <Input
            label="Title"
            name={`achievements[${idx}].title`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />
          <Input
            label="Type of Achievement"
            name={`achievements[${idx}].type_of_achievement`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />
          <Input
            label="Awarding"
            name={`achievements[${idx}].awarding`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />
          <Input
            label="Recognizing Body"
            name={`achievements[${idx}].recognizing_body`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />
          <Input
            label="Description"
            name={`achievements[${idx}].description`}
            register={register}
            errors={errors}
            type="text"
            disabled={disabled}
          />

          <Input
            label="Year"
            name={`achievements[${idx}].year`}
            register={register}
            errors={errors}
            duration
            disabled={disabled}
          />
          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}
      <div className={styles.buttonOuter}>
        <div></div>
        {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                title: "",
                type_of_achievement: "",
                awarding: "",
                recognizing_body: "",
                description: "",
                year: "",
              })
            }
          >
            + Add More
          </button>
        )}
      </div>
    </div>
  );
};

export default Achievements;
